import { render, staticRenderFns } from "./FutureFeatures.vue?vue&type=template&id=0b642100&scoped=true&"
import script from "./FutureFeatures.vue?vue&type=script&lang=js&"
export * from "./FutureFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b642100",
  null
  
)

export default component.exports